import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ActionSubmittingComponent
} from '../../../shared/ui/comment/modal-actions/action-submitting/action-submitting.component';
import {
  ActionSubmittedComponent
} from '../../../shared/ui/comment/modal-actions/action-submitted/action-submitted.component';


@Component({
    selector: 'app-finance-sources-modal',
    templateUrl: './finance-sources-modal.component.html',
    styleUrls: ['./finance-sources-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, ActionSubmittingComponent, ActionSubmittedComponent]
})
export class FinanceSourcesModalComponent implements OnInit {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Input() modalId = 'Finance-Source';
  @Input() tenantName: string;
  waitingResponse = true;
  successfulResponse = false;
  errorMessage: string | ((val: string | number) => string);

  ngOnInit() {}

  show() {
    this.successfulResponse = false;
    this.waitingResponse = true;
    this.modal.show();
  }

  setSuccessfulResponse() {
    this.successfulResponse = true;
    this.waitingResponse = false;
  }

  setErrorResponse() {
    this.successfulResponse = false;
    this.waitingResponse = false;
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }
}
